<span
  class="department-paused-badge"
  [class.department-paused-badge--icon-only]="iconOnly"
  [attr.aria-label]="iconOnly ? ('paused' | translate) : null"
  [attr.role]="iconOnly ? 'img' : null"
>
  @if (iconOnly) {
    <mat-icon class="department-paused-icon">pause</mat-icon>
  } @else {
    <mat-icon class="material-icons-outlined">pause</mat-icon>
    <span>{{ 'paused' | translate }}</span>
  }
</span>
